import { useMemo } from "react";

import { useQuery } from "@apollo/client";

import { type MyLensesLensCategory } from "../../gql-generated/types";
import { type ApolloResult } from "../../shared/models";
import {
    type GetLensCategoryListQuery,
    type GetLensCategoryListQueryVariables,
    getLensCategoryList,
} from "../api/queries";
import { mapLensCategoryList, mapLensCategoryMap } from "../effects";

export const useLensCategoryList = (): ApolloResult<{
    categoryMap: Record<string, MyLensesLensCategory>;
    categoryList: { data: MyLensesLensCategory; items: MyLensesLensCategory[] }[];
}> => {
    const { loading, data, error } = useQuery<GetLensCategoryListQuery, GetLensCategoryListQueryVariables>(
        getLensCategoryList,
    );

    const categoryMap: Record<string, MyLensesLensCategory> = useMemo(() => {
        return mapLensCategoryMap(data?.getLensCategoryList.lensCategoryList);
    }, [data]);

    const categoryList: { data: MyLensesLensCategory; items: MyLensesLensCategory[] }[] = useMemo(() => {
        return mapLensCategoryList(data?.getLensCategoryList.lensCategoryList);
    }, [data]);

    return {
        loading,
        error,
        categoryMap,
        categoryList,
    };
};
